import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import Config from "../../config/Config";
import { handleLongText } from "../../config/global";
import { ViolationPointCard } from "../cardComponent/violationPointCard";
import { LoadMoreButton } from "../buttonComponent/LoadMore";

const ViolationPointRewardMobile = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useState<any>(props.data);
  const [dataPoint, setDataPoint] = useState<any>(props.dataPoint);
  const [list, setList] = useState<any>([])
  const [studentSelected, setStudentSelected] = useState<any>({ ...props.studentSelect, photoUrl: '' });
  const env = Config.BaseUrlDev;
  const startDateRef = useRef<HTMLInputElement>(null);
  const endDateRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) { }
  }, [location.pathname.split("/")[2]]);

  function closeModal() {
    setIsOpen(false);
  }

  const handleRefresh = async () => { };

  const goToDetail = async (data: string) => {
    navigate(`/attendance-detail`, {
      state: {
        data: JSON.stringify(data),
        date: moment().format("yyyy-MM-DD"),
      },
    });
  };

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[95dvh]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div
                  // onClick={() => setIsOpen(true)}
                  className="bg-white p-3 rounded-xl flex-row flex gap-1 items-center flex-0 w-full justify-between"
                >
                  <div className="flex flex-row gap-1 w-[60%] ">
                    <div className="flex flex-row w-12 h-12 " >
                      <img
                        src={props.getProfileImage(studentSelected.photoUrl || '')}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                    <div className="flex flex-col grow ">
                      <span className="font-montserrat text-xs font-medium text-psp-nav">
                        {handleLongText(studentSelected.name, 15)}
                      </span>
                      <span className="font-montserrat  font-medium text-psp-gray text-xs">
                        {studentSelected.classroomName}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col w-[37%] items-center">
                    <span className="font-montserrat text-3xl font-bold text-[#FFBE0C]">
                      {dataPoint.reward?.point || 0}
                    </span>
                    <span className="font-montserrat font-medium text-psp-nav text-center text-sm">
                      Poin Reward
                    </span>
                  </div>
                </div>
                <span className="mt-3">Riwayat Reward</span>
                <div className="rounded-lg flex gap-1">
                  <button onClick={() => { props.setStartDate(''); props.setEndDate('') }} className={`px-2 py-2 border-1 ${!props.startDate && !props.endDate ? 'bg-[#0054e6] text-white' : ' text-[#0054e6]'} border-[#0054e6] font-medium text-xs rounded-md`}>All</button>
                  <div className="flex gap-1 w-[calc(100%-37px)]">
                    <form className="bg-white rounded-lg w-1/2">
                      <input
                        type="date"
                        value={props.startDate}
                        ref={startDateRef}
                        onChange={(e) => props.setStartDate(e.target.value)}
                        className="py-1 px-2 w-full border rounded-lg disabled:text-gray-500"
                      ></input>
                    </form>
                    <form className="bg-white rounded-lg w-1/2">
                      <input
                        type="date"
                        value={props.endDate}
                        ref={endDateRef}
                        onChange={(e) => props.setEndDate(e.target.value)}
                        className="py-1 px-2 w-full border rounded-lg disabled:text-gray-500"
                      ></input>
                    </form>
                  </div>
                </div>
                <div className={`mt-3 ${props.data.length % props.pagination.size == 0 && 'mb-10'} flex flex-col gap-2 max-h-[70dvh] overflow-y-auto`}>
                  {
                    data.map((item: any, index: number) => (<ViolationPointCard getProfileImage={props.getProfileImage} data={item} type="reward"></ViolationPointCard>))
                  }
                  {
                    props.data.length % props.pagination.size == 0 && props.data != 0 &&
                    <LoadMoreButton onClick={() => props.fetchData({ startDate: props.startDate, endDate: props.endDate }, true)}></LoadMoreButton>
                  }
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      Pilih
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2 flex flex-col gap-2">

                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ViolationPointRewardMobile;
